<template>
  <div class='content' style='width: 700px; height: 580px'>
    <div ref='charts' style='width: 700px; height: 580px'></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import shaoxing from '@/assets/mapJson/data-city.json'
import keqiao from '@/assets/mapJson/data-keqiao.json'
import shangyu from '@/assets/mapJson/data-shangyu.json'
import shengzhou from '@/assets/mapJson/data-shengzhou.json'
import xinchang from '@/assets/mapJson/data-xinchang.json'
import yuecheng from '@/assets/mapJson/data-yuecheng.json'
import zhuji from '@/assets/mapJson/data-zhuji.json'
import { chartssize } from '@/utils/resize'
export default {
  data () {
    return {
      charts: {},
      data: [
        { name: '测试数据', value: [120.76, 29.42, 2333] },
        { name: '测试数据', value: [120.58, 29.65, 2333] },
        { name: '测试数据', value: [120.85, 29.75, 2333] },
        { name: '测试数据', value: [120.93, 29.82, 2333] },
        { name: '测试数据', value: [120.53, 29.75, 2333] },
        { name: '测试数据', value: [120.59, 29.88, 2333] },
        { name: '测试数据', value: [120.69, 29.9, 2333] },
        { name: '测试数据', value: [120.35, 29.85, 2333] },
        { name: '测试数据', value: [120.43, 29.99, 2333] }
      ],
      type: 'city'// area
    }
  },
  created () {
    this.$nextTick(() => {
      this.initCharts()
    })
  },
  mounted () {
    const ct = this.$refs['charts']
    window.addEventListener('resize', () => {
      chartssize(ct, this.charts, 0, 0)
    })
  },
  methods: {
    initCharts () {
      this.charts = echarts.init(this.$refs['charts'])
      const option = {
        // 背景颜色
        backgroundColor: '#ffffff00',
        // 提示浮窗样式
        tooltip: {
          show: true,
          trigger: 'item',
          alwaysShowContent: false,
          backgroundColor: '#0C121C',
          borderColor: 'rgba(0, 0, 0, 0.16);',
          hideDelay: 100,
          triggerOn: 'mousemove',
          enterable: true,
          textStyle: {
            color: '#DADADA',
            fontSize: '12',
            width: 20,
            height: 30,
            overflow: 'break'
          },
          showDelay: 100
        },
        // 地图配置
        geo: {
          map: 'shaoxing',
          aspectScale: 0.8,
          roam: false,
          label: {
            // 通常状态下的样式
            normal: {
              show: false
            },
            // 鼠标放上去的样式
            emphasis: {
              textStyle: {
                color: '#fff'
              }
            }
          },
          // 地图区域的样式设置
          itemStyle: {
            normal: {
              borderColor: '#3577d4',
              borderWidth: 1,
              areaColor: {
                // type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  {
                    offset: 1,
                    color: '#a9d3ff' // 100% 处的颜色
                  }
                ],
                globalCoord: false // 缺省为 false
              },
              shadowColor: '#90c6ff',
              shadowOffsetX: 3,
              shadowOffsetY: -3,
              shadowBlur: 12
            },
            // 鼠标放上去高亮的样式
            emphasis: {
              areaColor: '#fe5400',
              borderWidth: 0
            }
          }
        },
        series: [
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            effectType: 'ripple',
            showEffectOn: 'render',
            symbolSize: window.innerWidth < 500 ? '5' : '10',
            rippleEffect: {
              period: 5,
              scale: 3,
              brushType: 'fill'
            },
            hoverAnimation: true,
            itemStyle: {
              normal: {
                color: 'rgba(255, 235, 59, .7)',
                shadowBlur: 10,
                shadowColor: '#333'
              }
            },
            zlevel: 1,
            data: this.data
          }
        ]
      }
      // 地图注册，第一个参数的名字必须和option.geo.map一致
      echarts.registerMap('shaoxing', shaoxing)

      this.charts.setOption(option)

      this.charts.on('click', ({name}) => {
        if (this.type === 'city') {
          // 重新配置散点
          option.series[0].data = []
        }
        if (name === '柯桥区' && this.type === 'city') {
          this.type = 'area'
          // 修改option的配置，可以继续自定义
          option.geo.zoom = 0.8
          // 就像上面提到的，这里必须要和注册地图时的名字一致
          option.geo.map = 'keqiao'
          // 注册地图
          echarts.registerMap('keqiao', keqiao)
          // 重新渲染
          this.charts.setOption(option, true)
        } else if (name === '越城区' && this.type === 'city') {
          this.type = 'area'
          // 修改option的配置，可以继续自定义
          option.geo.zoom = 0.8
          // 就像上面提到的，这里必须要和注册地图时的名字一致
          option.geo.map = 'yuecheng'
          // 注册地图
          echarts.registerMap('yuecheng', yuecheng)
          // 重新渲染
          this.charts.setOption(option, true)
        } else if (name === '上虞区' && this.type === 'city') {
          this.type = 'area'
          // 修改option的配置，可以继续自定义
          option.geo.zoom = 0.8
          // 就像上面提到的，这里必须要和注册地图时的名字一致
          option.geo.map = 'shangyu'
          // 注册地图
          echarts.registerMap('shangyu', shangyu)
          // 重新渲染
          this.charts.setOption(option, true)
        } else if (name === '诸暨市' && this.type === 'city') {
          this.type = 'area'
          // 修改option的配置，可以继续自定义
          option.geo.zoom = 0.8
          // 就像上面提到的，这里必须要和注册地图时的名字一致
          option.geo.map = 'zhuji'
          // 注册地图
          echarts.registerMap('zhuji', zhuji)
          // 重新渲染
          this.charts.setOption(option, true)
        } else if (name === '嵊州市' && this.type === 'city') {
          this.type = 'area'
          // 修改option的配置，可以继续自定义
          option.geo.zoom = 0.8
          // 就像上面提到的，这里必须要和注册地图时的名字一致
          option.geo.map = 'shengzhou'
          // 注册地图
          echarts.registerMap('shengzhou', shengzhou)
          // 重新渲染
          this.charts.setOption(option, true)
        } else if (name === '新昌县' && this.type === 'city') {
          this.type = 'area'
          // 修改option的配置，可以继续自定义
          option.geo.zoom = 0.8
          // 就像上面提到的，这里必须要和注册地图时的名字一致
          option.geo.map = 'xinchang'
          // 注册地图
          echarts.registerMap('xinchang', xinchang)
          // 重新渲染
          this.charts.setOption(option, true)
        } else {
          this.type = 'city'
          option.geo.zoom = 1
          // 就像上面提到的，这里必须要和注册地图时的名字一致
          option.geo.map = 'shaoxing'
          // 重新配置散点
          option.series[0].data = this.data
          // 注册地图
          echarts.registerMap('shaoxing', shaoxing)
          this.charts.setOption(option)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Map/index.vue